import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ModalCreateTaskAsync = lazyWithRetry(() => import('./modal-create-task'))
